import { render, staticRenderFns } from "./DPeriodTreeSelect.vue?vue&type=template&id=2d05eda7&"
import script from "./DPeriodTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DPeriodTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports